class FactoryClass {
  constructor(data = {}) {
    this.factoryCode = data.siteOfficeMasterCode;
    this.factoryName = data.siteOfficeMasterName;
  }
}
export default FactoryClass;
